export default "__VITE_ASSET__DPvRf3D0__"